enum MaterialPatrimonyTypeEnum {
    //ARCHAEOLOGICAL = 'ARCHAEOLOGICAL', //Arqueológico
    IMMOVABLE = 'IMMOVABLE', //Imóvel
    //LANDSCAPING = 'LANDSCAPING', //Paisagístico
    MOVABLE = 'MOVABLE', //Móvel ou Integrado
    //PALEONTOLOGICAL = 'PALEONTOLOGICAL', //Paleontológico
}

export default MaterialPatrimonyTypeEnum;
